import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Article from 'src/smoothr-web-app-core/models/Article';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import FulfilledDependency from 'src/smoothr-web-app-core/models/FulfilledDependency';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
import Order from 'src/smoothr-web-app-core/models/Order';
import { OrderUtils } from 'src/smoothr-web-app-core/utils/order-utils';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';
import { ValidationUtils } from 'src/smoothr-web-app-core/utils/validation-utils';

@Component({
	selector: 'app-extra-option-modal',
	templateUrl: './extra-option-modal.component.html',
	styleUrl: './extra-option-modal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtraOptionModalComponent implements OnInit {
	articleGroup: ArticleGroup;
	optionGroup: OptionGroup;
	order: Order;

	OrderUtils = OrderUtils;
	validationUtils = ValidationUtils;
	fulfilledDependency: FulfilledDependency;

	constructor(private modalCtrl: ModalController) {}

	static async show(modalCtrl: ModalController, order: Order, articleGroup: ArticleGroup, optionGroup: OptionGroup): Promise<void> {
		const modal = await modalCtrl.create({
			cssClass: 'extra-option-modal',
			component: ExtraOptionModalComponent,
			componentProps: {
				articleGroup,
				optionGroup,
				order,
			},
			showBackdrop: true,
			backdropDismiss: false,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		await sleep(200);
		return result;
	}

	ngOnInit(): void {
		this.fulfilledDependency = this.validationUtils.isGroupDependencyFulfilled(
			this.articleGroup.article,
			this.articleGroup.groups,
			this.optionGroup
		);
	}

	public addOption(event: ArticleOption) {
		OrderUtils.addOption(this.articleGroup.groups, event, this.optionGroup, this.fulfilledDependency);
	}

	count(article: Article) {
		return this.articleGroup.groups.filter(ao => ao.article._id === article._id).reduce((prev, curr) => prev + curr.quantity, 0);
	}

	onAdd(article: Article) {
		const articleOption = new ArticleOption();
		articleOption.article = article;
		articleOption.group = this.optionGroup._id;
		articleOption.quantity = 1;
		this.addOption(articleOption);
	}

	onRemove(article: Article) {
		const articleOption = new ArticleOption();
		articleOption.article = article;
		articleOption.group = this.optionGroup._id;
		articleOption.quantity = -1;
		this.addOption(articleOption);
	}

	close() {
		this.modalCtrl.dismiss();
	}
}
